var SupportFinePrintServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtilsHelper = require('../../../helpers/utils');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportFinePrintServiceActionView = (function(superClass) {
  extend(SupportFinePrintServiceActionView, superClass);

  function SupportFinePrintServiceActionView() {
    return SupportFinePrintServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportFinePrintServiceActionView.prototype.id = 'id_fine_print';

  SupportFinePrintServiceActionView.prototype.events = {
    'click #fine_print': 'showFinePrint'
  };

  SupportFinePrintServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportFinePrintServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportFinePrintServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: 'fine_print',
      service_action: I18n.t("js.modules.support.viewfp")
    };
    return this.extendHash(hash);
  };

  SupportFinePrintServiceActionView.prototype.showFinePrint = function() {
    return SupportUtilsHelper.renderFinePrint();
  };

  return SupportFinePrintServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportFinePrintServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvZmluZV9wcmludF9zZXJ2aWNlX2FjdGlvbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL3NlcnZpY2VfYWN0aW9ucy9maW5lX3ByaW50X3NlcnZpY2VfYWN0aW9uLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHdIQUFBO0VBQUE7OztBQUFBLGtCQUFBLEdBQXFCLE9BQUEsQ0FBUSx3QkFBUjs7QUFDckIsNkJBQUEsR0FBZ0MsT0FBQSxDQUFRLHVCQUFSOztBQUNoQyxrQ0FBQSxHQUFxQyxPQUFBLENBQVEsaURBQVI7O0FBRS9COzs7Ozs7OzhDQUNKLEVBQUEsR0FBSTs7OENBRUosTUFBQSxHQUNFO0lBQUEsbUJBQUEsRUFBcUIsZUFBckI7Ozs4Q0FFRixVQUFBLEdBQVksU0FBQTtJQUNWLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBVixDQUFnQixDQUFoQixFQUFtQixDQUFDLElBQUQsQ0FBTSxDQUFDLE1BQVAsQ0FBYyxDQUFDLENBQUMsU0FBRixDQUFZLElBQVosQ0FBZCxDQUFuQjtJQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZO1dBQ1osSUFBQyxDQUFBLEtBQUQsR0FBUyxPQUFPLENBQUMsT0FBTyxDQUFDO0VBSmY7OzhDQU1aLE1BQUEsR0FBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbEIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVo7RUFETTs7OENBR1IsTUFBQSxHQUFRLFNBQUE7QUFDTixRQUFBO0lBQUEsSUFBQSxHQUNFO01BQUEsaUJBQUEsRUFBb0IsWUFBcEI7TUFDQSxjQUFBLEVBQWlCLElBQUksQ0FBQyxDQUFMLENBQU8sMkJBQVAsQ0FEakI7O1dBRUYsSUFBQyxDQUFBLFVBQUQsQ0FBWSxJQUFaO0VBSk07OzhDQU1SLGFBQUEsR0FBZSxTQUFBO1dBQ2Isa0JBQWtCLENBQUMsZUFBbkIsQ0FBQTtFQURhOzs7O0dBckIrQjs7QUF3QmhELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
